export const ADD_TODO = 'ADD_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const TOGGLE_COMPLETED = 'TOGGLE_COMPLETED';
export const CLEAR_COMPLETED = 'CLEAR_COMPLETED';
export const SET_FILTER = 'SET_FILTER';
export const UPDATE_TODOS_LIST = 'UPDATE_TODOS_LIST';

export const SET_THEME = 'SET_THEME';
